import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type GlobalState = {
  receiveDate: Date | undefined
}

const globalSlice = createSlice({
  name: 'global',
  initialState: {
    receiveDate: undefined
  } as GlobalState,
  reducers: {
    setReceiveDate(state, action: PayloadAction<Date>) {
      state.receiveDate = action.payload;
    }
  }
});

const globalReducer = globalSlice.reducer;
export const {setReceiveDate} = globalSlice.actions;
export default globalReducer;